import $ from 'jquery'
import 'bootstrap'
import 'sortablejs'
import 'js-cookie'
import './modules/cms-datepicker'
import './modules/cms-select2'
import './modules/cms-user-code'
import './modules/cms-captcha'

import '@fancyapps/fancybox'

import systemsightAjaxFormHandler from "./modules/cms-ajax-form";
import systemsightFormConditions from "./modules/cms-form-conditions";



